export var TypeModal;
(function (TypeModal) {
    TypeModal[TypeModal["Menu"] = 0] = "Menu";
    TypeModal[TypeModal["Dialog"] = 1] = "Dialog";
    TypeModal[TypeModal["TransparentDialog"] = 2] = "TransparentDialog";
    TypeModal[TypeModal["ErrorDialog"] = 3] = "ErrorDialog";
})(TypeModal || (TypeModal = {}));



//////////////////
// WEBPACK FOOTER
// ./src/features/modals/TypeModal.ts
// module id = 266
// module chunks = 3